import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth.jsx";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import {
  LayoutDashboard, Plus, LogOut, FileSearch, Plug, Wifi, Users, Building2, Briefcase,
} from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-[12px] text-sm font-medium transition-colors ${
      isActive
        ? "bg-[#D85A30] text-white"
        : "text-[#2C2C2A] hover:bg-[#FAECE7]"
    }`;

  return (
    <div className="min-h-screen flex bg-[#FBFAF6]">
      <aside className="w-64 border-r border-[#E5E2D8] bg-white flex flex-col" data-testid="perito-sidebar">
        <div className="px-5 py-6 border-b border-[#E5E2D8]">
          <Logo size={34} />
        </div>
        <nav className="px-3 py-4 space-y-1 flex-1">
          <NavLink to="/" end className={linkClass} data-testid="nav-dashboard">
            <LayoutDashboard className="h-4 w-4" /> Inicio
          </NavLink>
          <NavLink to="/siniestros/new" className={linkClass} data-testid="nav-new-siniestro">
            <Plus className="h-4 w-4" /> Nueva peritación
          </NavLink>
          <NavLink to="/telematico/new" className={linkClass} data-testid="nav-new-telematico">
            <Plus className="h-4 w-4" /> Nuevo Telemático
          </NavLink>
          <NavLink to="/integracion" className={linkClass} data-testid="nav-integracion">
            <Plug className="h-4 w-4" /> Integración
          </NavLink>
          {user?.role === "admin" || user?.role === "superadmin" ? (
            <NavLink to="/equipo" className={linkClass} data-testid="nav-equipo">
              <Users className="h-4 w-4" /> Equipo
            </NavLink>
          ) : null}
          {user?.role === "admin" || user?.role === "superadmin" ? (
            <NavLink to="/admin/companias" className={linkClass} data-testid="nav-companias">
              <Briefcase className="h-4 w-4" /> Compañías
            </NavLink>
          ) : null}
          {user?.role === "superadmin" && (
            <NavLink to="/admin/organizaciones" className={linkClass} data-testid="nav-orgs">
              <Building2 className="h-4 w-4" /> Organizaciones
            </NavLink>
          )}
        </nav>
        <div className="px-4 py-4 border-t border-[#E5E2D8]">
          <div className="text-xs text-[#7A786F] mb-1">
            {user?.role === "superadmin" ? "Superadministrador" : user?.role === "admin" ? "Administrador" : user?.role === "tramitador" ? "Tramitador" : "Perito"}
            {user?.org_name && <> · {user.org_name}</>}
          </div>
          <div className="text-sm font-medium text-[#2C2C2A] truncate" data-testid="perito-name">{user?.name}</div>
          <div className="text-xs text-[#7A786F] truncate mb-3">{user?.email}</div>
          <Button
            variant="outline"
            size="sm"
            className="w-full border-[#E5E2D8] hover:bg-[#FAECE7]"
            onClick={() => { logout(); nav("/login"); }}
            data-testid="logout-btn"
          >
            <LogOut className="h-4 w-4 mr-2" /> Cerrar sesión
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <header className="h-16 border-b border-[#E5E2D8] bg-[#FBFAF6]/80 backdrop-blur flex items-center justify-between px-8">
          <div className="flex items-center gap-2 text-sm text-[#7A786F]">
            <FileSearch className="h-4 w-4" /> Panel del perito
          </div>
          <div className="flex items-center gap-2 text-xs text-[#7A786F]">
            <Wifi className="h-3.5 w-3.5 text-[#1D9E75]" /> Conectado a Ekspertium
          </div>
        </header>
        <div className="p-8">{children}</div>
      </main>
    </div>
  );
}
